import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from '@/store/store.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar);
Vue.use(VueQuillEditor)
Vue.use(ElementUI);
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
